export default {"src":"/_next/static/media/biology.5de8f47b.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};